import styled from 'styled-components';

const SearchOptionPanelStyle = styled.div`
    width: 400px;
    height: auto;
    position: relative; 
    z-index: 50;
    padding: 1rem; 
    border-radius: 3px;
    border: rgb(210,210,210) solid 1px;
    background: white; 
    color: rgb(60,60,60); 
    font-size: 14px;
    box-shadow: 0px 0px 30px 10px rgba(240,240,240,1); 
`

export default SearchOptionPanelStyle;